export default function isModal() {
  return window !== window.top;
}


/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/isModal.js
 **/